import * as style from "./style";
import * as CONSTANTS from '../../constants'

export const Footer = () => {
  return (
    <style.Footer>{CONSTANTS.FOOTER_TITLE}</style.Footer>
  );
};
